import { createTheme } from "@mui/material";
import { AmplifyConfig, InterfaceConfig } from "@interfaces/index";
import { themeBase } from "./_themeBase";

export const CustomTheme = createTheme(themeBase, {
  palette: {
    primary: {
      main: "#253787", //"#528CD6",
      dark: "#253787",
      light: "#336699", //"#A3D4E8",
    },
    secondary: {
      main: "#33AE29",
    },
    backgroundRight: {
      main: "#253787", //"#528CD6",
      dark: "#253787",
      light: "#A3D4E8",
      tab: "#E9F4E6", //"#E0F7FA",
    },
    phoneInput: {
      main: "#E9F4E6", //"#E3F2F8",
    },
    otherColors: {
      main: "#FFFFFF",
      backgroundsColors: "#FFFFFF",
      tabText: "#FFFFFF",
      tabBackground: "#242424", //"#253787",
      menuIcon: "#253787", //"#528CD6",
      switch_color: "#33AE29",
    },
    barProgress: {
      main: "#0A8800", //"#528CD6",
    },
    marketPlace: {
      main: "#FFFFFF",
      cardBackground: "#C2E5F3",
    },
    cotizador: {
      backgroundColor: "#E8E8FA", //"#E3F2F8",
      barColor: "#0A8800",
      iconColor: "#253787",
      markLabelColor: "#253787",
    },
    buttonSelected: {
      backgroundColor: "#BEDAB7", //"#528CD6",
      backgroundColorActive: "#2D5EAE",
      textColor: "#2D5EAE",
      textColorActive: "#FFFFFF",
      bordeColorActive: "#A3D4E8",
    },
    screenBackground: {
      backgroundColor: "#E9F4E6",
      textColor: "#2D5EAE",
      iconColor: "#253787",
      subTextColor: "#2D5EAE",

      backgroundColorBofu: "#E9F4E6",
      textColorBofu: "#2D5EAE",
      iconColorBofu: "#253787",
      subTextColorBofu: "#253787",
    },
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: "10px",
          },
          "& .MuiFilledInput-root": {
            borderRadius: "10px",
          },
          "& .MuiInputBase-root": {
            borderRadius: "10px",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#336699", //"#A3D4E8",
          },
          "& .MuiInput-underline::before": {
            borderColor: "#336699", //"#A3D4E8",
          },
          "& .MuiFilledInput-underline::before": {
            borderColor: "#336699", //"#A3D4E8",
          },
          "& .MuiInputLabel-asterisk": {
            color: "#CD0202",
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          padding: "10px 25px",
          textTransform: "none",
          fontSize: 16,
          fontWeight: 700,
        },
      },
      variants: [
        {
          props: {
            variant: "default",
          },
          style: {
            backgroundColor: "#253787", //"#528CD6",
            color: "#FFF",
            "&.Mui-disabled": {
              backgroundColor: "#253787", //"#528CD6",
              opacity: 0.4,
              color: "#FFF",
            },
            "&:hover": {
              backgroundColor: "#253787",
              color: "#A3D4E8",
            },
            "&.MuiButton-defaultSizeSmall": {
              fontSize: 11,
              fontWeight: 600,
              padding: "2px 8px",
            },
          },
        },
        {
          props: {
            variant: "default_disabled",
          },
          style: {
            backgroundColor: "#253787", //"#528CD6",
            opacity: 0.4,
            color: "#FFF",
            // "&.Mui-disabled": {
            //   backgroundColor: "#253787", //"#528CD6",
            //   opacity: 0.4,
            //   color: "#FFF",
            // },
            "&:hover": {
              backgroundColor: "#253787", //"#528CD6",
              color: "#FFF",
            },
            "&.MuiButton-defaultSizeSmall": {
              fontSize: 11,
              fontWeight: 600,
              padding: "2px 8px",
            },
          },
        },
        {
          props: {
            variant: "contained",
          },
          style: {
            "&.Mui-disabled": {
              backgroundColor: "#253787", //"#528CD6",
              opacity: 0.4,
              color: "#FFF",
            },
          },
        },
        {
          props: {
            variant: "orange",
          },
          style: {
            backgroundColor: "#F2704F",
            color: "#FFF",
            "&.Mui-disabled": {
              backgroundColor: "#F2704F",
              opacity: 0.4,
            },
            "&:hover": {
              backgroundColor: "#F2704F",
            },
          },
        },
        {
          props: {
            variant: "black",
          },
          style: {
            backgroundColor: "#2C2C2C",
            color: "#FFF",
            "&.Mui-disabled": {
              backgroundColor: "#2C2C2C",
              opacity: 0.4,
            },
            "&:hover": {
              backgroundColor: "#2C2C2C",
            },
          },
        },
        {
          props: {
            variant: "blue_outlined",
          },
          style: {
            color: "#253787",
            backgroundColor: "#FFF",
            border: "2px solid #253787",
            lineHeight: "22px",
            "&.Mui-disabled": {
              color: "#bdbdbd",
              border: "2px solid #bdbdbd",
              backgroundColor: "transparent",
            },
            "&.MuiButton-blue_outlinedSizeSmall": {
              fontSize: 11,
              fontWeight: 600,
              padding: "2px 8px",
            },
          },
        },
        {
          props: {
            variant: "blue_demon",
          },
          style: {
            // color: "#A3D4E8",
            color: "#FFFFFF",
            backgroundColor: "#253787",
            "&.Mui-disabled": {
              color: "#FFFFFF",
              backgroundColor: "#253787",
              opacity: 0.4,
            },
            "&:hover": {
              backgroundColor: "#253787",
            },
          },
        },
        {
          props: {
            variant: "green",
          },
          style: {
            color: "#FFFFFF",
            backgroundColor: "#00BB2D",
            "&.Mui-disabled": {
              backgroundColor: "#009A24",
              opacity: 0.4,
            },
            "&:hover": {
              backgroundColor: "#009A24",
            },
          },
        },
        {
          props: {
            variant: "expediente_validado",
          },
          style: {
            width: "150px",
            height: "30px",
            fontSize: 15,
            color: "#253787", //"#528CD6",
            backgroundColor: "#A3D4E8",
            "&.Mui-disabled": {
              backgroundColor: "#A3D4E8",
              opacity: 0.4,
            },
            "&:hover": {
              backgroundColor: "#A3D4E8",
            },
          },
        },
        {
          props: {
            variant: "expediente_validado",
            size: "small",
          },
          style: {
            width: "90px",
            height: "23px",
            fontSize: 13,
          },
        },
        {
          props: {
            variant: "expediente",
          },
          style: {
            paddingLeft: "10px",
            paddingRight: "10px",
            width: "150px",
            height: "30px",
            fontSize: 15,
            backgroundColor: "#253787", //"#528CD6",
            color: "#FFF",
            "&.Mui-disabled": {
              backgroundColor: "#253787", //"#528CD6",
              opacity: 0.4,
              color: "#FFF",
            },
            "&:hover": {
              backgroundColor: "#253787",
              color: "#A3D4E8",
            },
          },
        },
        {
          props: {
            variant: "expediente",
            size: "small",
          },
          style: {
            width: "90px",
            height: "23px",
            fontSize: 13,
          },
        },
        {
          props: {
            variant: "yellow",
          },
          style: {
            backgroundColor: "#FF9D14",
            color: "#FFF",
            "&.Mui-disabled": {
              backgroundColor: "#FF9D14",
              opacity: 0.4,
              color: "#FFF",
            },
            "&:hover": {
              backgroundColor: "#FF9D14",
              color: "#FFF",
            },
            "&.MuiButton-defaultSizeSmall": {
              fontSize: 11,
              fontWeight: 600,
              padding: "2px 8px",
            },
          },
        },
      ],
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          "& .MuiInputLabel-asterisk": {
            color: "#CD0202",
          },
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: "#33AE29", // Borde azul cuando no está enfocado
              borderRadius: "4px",
            },
            "&:hover fieldset": {
              borderColor: "#33AE29", // Borde azul al pasar el cursor
            },
            "&.Mui-focused fieldset": {
              borderColor: "#33AE29", // Borde azul cuando está enfocado
            },
          },
          "& .MuiSelect-icon": {
            color: "#33AE29", // Color del icono de selección
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          // "& .MuiSelect-icon": {
          //   color: "#A3D4E8",
          // },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#A3D4E8",
          },
        },
      },
    },
    MuiCircularProgress: {
      styleOverrides: {
        determinate: {
          color: "#E9F4E6",
        },
        indeterminate: {
          color: "#0A8800", //"#528CD6",
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          color: "#333F48",
        },
      },
    },
  },
});

export const interfaceConfig: InterfaceConfig = {
  name: "kapital_flex",
  home_url: import.meta.env.VITE_URL_HOME_KAPITAL_FLEX,
  aviso_privacidad: import.meta.env.VITE_URL_HOME_KAPITAL_FLEX + "/aviso-de-privacidad",
  terminos_condiciones: import.meta.env.VITE_URL_HOME_KAPITAL_FLEX + "/terminos-y-condiciones",
  interest_rate: 30,
  metadata: {
    title: "AceleraFlex",
    description:
      "AceleraFlex es una plataforma de crédito para PyMEs que ofrece créditos especializados para PyMEs con tasas competitivas y procesos ágiles. Obtén el financiamiento que tu empresa necesita para crecer.",
    favicon: "kapital_flex/portal/logos/favicon.ico",
    ogImage: "https://lendia.mx/opengraph-image.png?5ab5b324c6780cbc",
  },
  navbar: {
    logo: "kapital_flex/portal/logos/logo.png",
  },
  lateral: {
    logo_width: 250,
    logo_height: 50,
    logo_dark: "kapital_flex/portal/logos/logo_dark_bg.png",
    bg_light: CustomTheme.palette.primary.main,
    text_light: CustomTheme.palette?.otherColors?.main || "#FFFFFF",
    logo_light: "kapital_flex/portal/logos/logo_light_bg.png",
    bg_dark: CustomTheme.palette.secondary.main,
    text_dark: CustomTheme.palette?.otherColors?.main || "#FFFFFF",
    image_list: [
      "kapital_flex/portal/lateral/imagen_1.webp",
      "kapital_flex/portal/lateral/imagen_2.webp",
      "kapital_flex/portal/lateral/imagen_3.webp",
      "kapital_flex/portal/lateral/imagen_4.webp",
      "kapital_flex/portal/lateral/imagen_5.webp",
      "kapital_flex/portal/lateral/imagen_6.webp",
      "kapital_flex/portal/lateral/imagen_7.webp",
      "kapital_flex/portal/lateral/imagen_8.webp",
      "kapital_flex/portal/lateral/imagen_9.webp",
      "kapital_flex/portal/lateral/imagen_10.webp",
    ],
    text_list: [
      "Impulsa tu negocio con la flexibilidad de Acelera Flex",
      "Tu crédito, tus reglas, tu crecimiento",
      "Acelera tu empresa con financiamiento ágil y sin complicaciones",
      "La forma más simple de obtener capital para tu PyME",
      "Más liquidez para que tus planes no se detengan",
      "Crecer nunca fue tan sencillo",
      "Las mejores condiciones para acelerar tus proyectos",
      "El empuje que tu empresa necesita, justo a tiempo",
      "Soluciones claras para empresas que quieren más",
      "Decide, impulsa y acelera tu empresa con Acelera Flex",
    ],
  },
  textos_tofu: {
    pm: {
      crear_cuenta: {
        titulo: "Te damos la bienvenida",
        sub_titulo: "",
      },
      registro_datos_personales: {
        titulo: "Creación de cuenta",
        sub_titulo: "",
      },
      validacion_telefono: {
        titulo: "Validación de teléfono",
        sub_titulo: "",
      },
      datos_empresa_pm: {
        titulo: "Registro de empresa",
        sub_titulo: "",
      },
      consulta_ciec: {
        titulo: "Registro de empresa",
        sub_titulo: "",
      },
      uso_de_credito: {
        titulo: "Selección de uso de crédito",
        sub_titulo: "",
      },
      presencia_digital_pm: {
        titulo: "Presencia digital",
        sub_titulo: "",
      },
      datos_accionista: {
        titulo: "Registro del accionista mayoritario",
        sub_titulo: "",
      },
      rfc_curp: {
        titulo: "Registro del accionista mayoritario",
        sub_titulo: "",
      },
      domicilio_accionista: {
        titulo: "Registro del accionista mayoritario",
        sub_titulo: "",
      },
      consulta_buro_nip: {
        titulo: "Validación para consulta buró",
        sub_titulo: "",
      },
      buro_bloqueado: {
        titulo: "Consulta de Buró de Crédito del Accionista Bloqueada",
        sub_titulo: "",
      },
    },

    pfae: {
      datos_empresa_pfae: {
        titulo: "Registro de empresa",
        sub_titulo: "Ingresa los datos de la persona física con actividad empresarial",
      },
      consulta_buro_pfae: {
        titulo: "Consulta Buró",
        sub_titulo: "",
      },
      domicilio_pfae: {
        titulo: "Domicilio",
        sub_titulo: "",
      },
      presencia_digital_pfae: {
        titulo: "Presencia digital",
        sub_titulo: "",
      },
    },
  },
  maps: {
    api_key:
      import.meta.env.VITE_ENV === "PROD"
        ? "AIzaSyDAtCLTqWu3XTjTC6AT2ZysdXUtL33bAX4"
        : "AIzaSyAPkyPkzcAbvKAageB8UN25PKbzl4stiWc",
  },
  companyNames: ["Cumplo y Avanzo, S.A.P.I. DE C.V., SOFOM E.N.R.", "Lendit Group SAPI de CV"],
  text_accionista_check:
    "Declaro bajo protesta de decir verdad ser el Accionista mayoritario de la empresa mencionada en esta solicitud.",
};

export const amplifyConfig: AmplifyConfig = {
  dev: {
    client: {
      userPoolId: "us-east-1_dY5WpU3RR",
      userPoolClientId: "4v13vepumrl2r94entkcvuukg9",
    },
    guarantee: {
      userPoolId: "us-east-1_EdJB8vOre",
      userPoolClientId: "1gtf94j5udovq9deu5u13bbhvn",
    },
  },
  prod: {
    client: {
      userPoolId: "us-east-1_wiDGP4RIA",
      userPoolClientId: "6qg1j3lbjhss2njfqg86ibf5r5",
    },
    guarantee: {
      userPoolId: "us-east-1_78qrlwJTD",
      userPoolClientId: "451cn0u2mau2ipp479c39d75m5",
    },
  },
};
